<template>
  <div class="flex flex-wrap gap-3 mb-6 justify-end items-center">
    <button @click="createModal"
      class="bg-primary-button hover:bg-primary-button-hover text-white px-4 py-2 rounded transition-all duration-200 text-sm">
      + Yeni Sipariş Ekle
    </button>

    <input type="text" placeholder="Ara..." v-model="searchQuery"
      class="h-10 w-[300px] rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 px-4 text-sm text-primary-text dark:text-gray-100  focus:border-indigo-500 focus:ring focus:ring-blue-100/50" />
  </div>

  <div
    class="overflow-hidden rounded-md border border-light-border dark:border-dark-border bg-primary-bg dark:bg-primary-dark-bg pb-3 shadow-md">
    <div class="w-full overflow-x-auto">
      <table class="min-w-full text-left text-sm text-secondary-text dark:text-gray-300">
        <thead class=" bg-gray-100 dark:bg-gray-800 font-medium">
          <tr>
            <th class="px-3 md:px-6 py-2 md:py-4"></th>
            <th class="px-3 md:px-6 py-2 md:py-4">Sipariş Zamanı</th>
            <th class="px-3 md:px-6 py-2 md:py-4">Sipariş No</th>
            <th class="px-3 md:px-6 py-2 md:py-4">Yük Adı</th>
            <th class="px-3 md:px-6 py-2 md:py-4">Sipariş Tonaj</th>
            <th class="px-3 md:px-6 py-2 md:py-4">İşlemler</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in paginatedOrders" :key="order.order_id"
            class="border-b transition hover:light-hover dark:hover:dark-hover">
            <td class="px-3 md:px-6 py-2 md:py-4 font-medium text-primary-text dark:text-gray-100">{{
              getDealers(order.dealer_id) }}</td>
            <td class="px-3 md:px-6 py-2 md:py-4">{{ formatDate(order.order_time) }}</td>
            <td class="px-3 md:px-6 py-2 md:py-4 font-medium text-primary-text dark:text-gray-100">{{ order.order_number
            }}</td>
            <td class="px-3 md:px-6 py-2 md:py-4">
              {{order.products?.map(p => p.product_name).join(', ') || 'Ürün bulunamadı'}}</td>
            <td class="px-3 md:px-6 py-2 md:py-4">{{ order.siparis_tonaj }}</td>
            <td class="px-3 md:px-6 py-2 md:py-4 ">
              <button @click="editModal(order)" class="relative group">
                <PencilSquareIcon class="w-5 h-5 text-gray-500 hover:text-secondary-text" />
                <span
                  class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">
                  Düzenle
                </span>
              </button>
              <button @click="deleteModal(order)" class="relative group">
                <TrashIcon class="w-5 h-5 text-red-500 hover:text-red-600" />
                <span
                  class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">Sil</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <AppPagination :currentPage="currentPage" :totalPages="totalPages" @prev-page="currentPage--"
      @next-page="currentPage++" @go-to-page="page => currentPage = page" />

    <DeleteModal v-if="isDeleteModal" :item="selectedOrder" message="Bu siparişi silmek istediğinizden emin misiniz?"
      @close="isDeleteModal = false" @confirm-delete="handleDelete" @click.self="isDeleteModal = false" />

    <OrderModal v-if="isModalOpen" :mode="modalMode" :order="selectedOrder" :dealerId="$route.params.dealerId"
      @submit="fetchOrders" @close="closeModal" />

  </div>
</template>

<script>
import { getApi, deleteApi } from "@/services/api"
import OrderModal from '@/components/Modals/OrderModal.vue';
import DeleteModal from '@/components/Modals/DeleteModal.vue';
import { PencilSquareIcon, TrashIcon } from '@heroicons/vue/24/outline';

export default {
  name: 'OrderList',
  components: { PencilSquareIcon, TrashIcon, OrderModal, DeleteModal },
  data() {
    return {
      currentPage: 1,
      pageSize: 13,
      searchQuery: '',
      modalMode: 'edit',
      selectedOrder: null,
      isModalOpen: false,
      isDeleteModal: false,
      dealers: [],
      orders: [],
      products: [],
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.filteredOrders.length / this.pageSize);
    },
    filteredOrders() {
      const query = this.searchQuery.toLowerCase();
      return this.orders.filter(order =>
        order.order_number.toLowerCase().includes(query)
      );
    },
    paginatedOrders() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.filteredOrders.slice(start, start + this.pageSize);
    },
  },
  methods: {
    createModal() {
      this.modalMode = 'create';
      this.selectedOrder = {};
      this.isModalOpen = true;
    },
    editModal(order) {
      this.modalMode = 'edit';
      this.selectedOrder = order;
      this.isModalOpen = true;
    },
    deleteModal(order) {
      this.selectedOrder = order;
      this.isDeleteModal = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.selectedOrder = null;
    },
    deleteOrder(id) {
      this.orders = this.orders.filter(order => order.order_id !== id);
      alert(`Sipariş #${id} silindi!`);
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('tr-TR');
    },

    async fetchOrders() {
      const dealerId = this.$route.params.dealerId;

      try {
        const response = await getApi('/orders');
        const allOrders = response;

        if (dealerId) {
          this.orders = allOrders.filter(order => order.dealer_id === Number(dealerId));
        } else {
          this.orders = allOrders;
        }

      } catch (error) {
        console.error('Siparişler alınırken hata oluştu:', error);
      }
    },

    async handleDelete(order) {
      try {
        await deleteApi(`/orders/${order.order_id}`);
        this.$toast.success("Sipariş başarıyla silindi!");
        this.fetchOrders();
      } catch (error) {
        this.$toast.error("Silme işlemi sırasında hata oluştu!");
      } finally {
        this.isDeleteModal = false;
      }
    },

    async fetchDealers() {
      try {
        const dealerList = await getApi("/dealers");
        this.dealers = dealerList;
      } catch (error) {
        console.error("Bayiler alınırken hata oluştu:", error);
      }
    },

    getDealers(id) {
      const dealer = this.dealers.find(d => d.dealer_id === id);
      return dealer ? dealer.dealer_name : "Bayi bulunamadı";
    },

    async fetchProducts() {
      try {
        const response = await getApi('/products');
        this.products = response;
      } catch (error) {
        console.error("Ürünler alınırken hata oluştu:", error);
      }
    },

    getProducts(id) {
      const product = this.products.find(p => p.product_id === id);
      return product ? product.product_name : "Ürün bulunamadı";
    },

  },
  watch: {
    searchQuery() {
      this.currentPage = 1;
    },
    '$route.params.dealerId'() {
      this.fetchOrders();
    }
  },
  mounted() {
    this.fetchOrders();
    this.fetchDealers();
    this.fetchProducts();
  }
};
</script>